import { mapGetters, mapState } from 'vuex'
import lang from '@data/lang.json'

const ShoppingCart = {
  props: [
    'getEndpoint',
    'editEndpoint'
  ],
  data () {
    return {
      lang: lang.ShoppingCart,
      showCart: false
    }
  },
  computed: {
    ...mapGetters('cart', {
      totalPrice: 'totalPrice',
      products: 'cartProducts',
    }),
    ...mapState({
      quantity: state => state.cart.totalItems,
      status: state => state.cart.status
    })
  },
  methods: {
    handleToggle: function(toggleValue) {
      bus.$emit('shopping_cart', toggleValue) // Set shopping-cart-toggle value
      bus.$emit('nav_toggled', false)
      this.showCart = toggleValue
      document.querySelector('html').classList.toggle('shopping-cart--active', toggleValue)
    },
    decrementProduct (id, quantity) {
    // console.log('decrement INDATA', id, quantity)
      const productId = id
      let newQuantity = quantity -1 >= 0 ? quantity -1 : 0
      newQuantity = parseInt(newQuantity)

    // console.log('decrement', productId, newQuantity)

      this.$store.dispatch(
        'cart/setCart', {
          api: this.editEndpoint,
          params: {
            ItemId: productId,
            Quantity: newQuantity
          }
        }
      )
    },
    setShoppingCartBodyHeight () {
      const shoppingCartBody = this.$refs.shopping_cart_body
      shoppingCartBody.style.height = '100%'

      if (this.showCart) {
        shoppingCartBody.style.height = shoppingCartBody.getBoundingClientRect().height + 'px'
      }
    }
  },
  created () {
    bus.$on('shopping_cart_toggle', isActive => {
      this.handleToggle(isActive)
    })
    bus.$on('window_resize', () => {
      this.setShoppingCartBodyHeight()
    })
  },
  mounted () {
    this.$store.dispatch(
      'cart/getCart', {
        api: this.getEndpoint,
        params: null
      }
    )
  },
  updated () {
    this.setShoppingCartBodyHeight()
  },
}

export default ShoppingCart
